import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import {
  Auth,
  getAuth,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
};

let _app: FirebaseApp | undefined;
let _auth: Auth | undefined;

function getFirebaseApp(): FirebaseApp {
  if (!_app) {
    _app =
      getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
  }
  return _app;
}

function getFirebaseAuth(): Auth {
  if (!_auth) {
    const tenantId = process.env.NEXT_PUBLIC_FIREBASE_YFP_TENANT_ID;
    if (!tenantId) {
      throw new Error(
        "NEXT_PUBLIC_FIREBASE_YFP_TENANT_ID is required: YFP must be scoped to its Identity Platform tenant to keep credentials isolated from the default consumer pool.",
      );
    }
    _auth = getAuth(getFirebaseApp());
    _auth.tenantId = tenantId;
    // Store tokens in sessionStorage (not cookies) per RFC
    setPersistence(_auth, browserSessionPersistence);
  }
  return _auth;
}

// Lazy getter – Firebase is only initialized when `auth` is first accessed,
// avoiding the "invalid-api-key" crash during Next.js static page generation
// where NEXT_PUBLIC_* env vars are not available.
export const auth: Auth = new Proxy({} as Auth, {
  get(_target, prop) {
    const realAuth = getFirebaseAuth();
    const value = Reflect.get(realAuth, prop);
    // Bind methods to the real Auth instance so `this` is correct
    if (typeof value === "function") {
      return value.bind(realAuth);
    }
    return value;
  },
});
